import { apiFinancialsList } from "api/financialApi";
import { apiProductsList } from "api/productApi";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setOpeningBalanceData } from "store/actions/openingBalanceAction";
import { apiGetAccountingTypeDetails, apiGetAccountingTypes } from "api/accountingTypeApi";
import { apiDeleteOpennigBlance, apiGetOpeningBalance, apiSetOpeningBalance, getTypeId, typeIds } from "api/openingBalanceApi";
import { apiGetWarehouses } from "api/warehouseApi";
import { apiPersonsList } from "api/personApi";
import shortid from "shortid";
import Price from "components/Table2/CellComps/Price";
import Select from "components/Table2/CellComps/Select";
import Text from "components/Table2/CellComps/Text";
import Number from "components/Table2/CellComps/Number";
import DateComp from "components/Table2/CellComps/Date";
import { appSetAlert, setConfirm } from "store/actions/appAction";
import getCurrency from "helpers/currencyHelper";
import axios from "../../axios/axios";
import { setSelectItemLabels } from "helpers";
import { setAccounting } from "store/actions/accountingAction";

export default function useOpeningBalanceData() {
  const dispatch: any = useDispatch();
  const store = useSelector((state: any) => state);
  const loading = useSelector((state: any) => state.appReducer.loading);
  const { banks, cashiers, funds }: FinanceReducer = store.financialReducer;
  const { products }: ProductReducer = store.productReducer;
  const { token } = store.businessReducer.business;
  const { allPerson } = store.personReducer;
  const { warehouses }: any = store.warehouseReducer;
  const accountingTypes = store.accountingReducer.accountingTypes;
  const openingBalance: OpeningBalanceItem[] = store.openingBalanceReducer.openingBalance;
  const openingBalanceId: string | number = store.openingBalanceReducer.id;
  const [debtor, setDebtor] = useState({})
  const [count, setCount] = useState(0);
  const [date, setDate] = useState("")
  const openingBalanceItemInit = {
    id: 0,
    detailId: 0,
    title: "",
    unit: 0,
    barcode: 0,
    warehouse: "",
    count: 1,
    price: 0,
    currencyPrice: 0,
    currency: getCurrency().defCur.en_title,
    totalPrice: 0,
    date: Intl.DateTimeFormat("fa-IR-u-nu-latn").format(Date.now()),
    delegationDate: Intl.DateTimeFormat("fa-IR-u-nu-latn").format(Date.now()),
  };
  const getDetails = async (accountingTypeId?: number | string) => {
    const response = await axios
      .get(`/accountTypes/${accountingTypeId}/details`, {
        headers: { Authorization: `Bearer ${token}` },
      })
    let details = response.data.details;
    if (details && details.length) {
      details = setSelectItemLabels(
        details,
        "id",
        details[0].name ? "name" : details[0].title ? "title" : "nickName"
      );
    }
    setAccounting(details);
    return details

  }
  const deleteOpenningBalanceApi = (deleteChequeAccounting: boolean) => {
    dispatch(apiDeleteOpennigBlance({ openingBalance: { id: openingBalanceId, deleteChequeAccounting }, token }))
  }
  const setOtherDebtsDetails = async (res: any[]) => {
    const newData: any[] = []
    for (const curRow of res) {
      if (curRow.type === "otherDebt") {
        let details = await getDetails(curRow.accountTypeId)
        newData.push({ ...curRow, details })
      } else {
        newData.push({ ...curRow })
      }
    }
    dispatch(setOpeningBalanceData(newData));

  }
  useEffect(() => {
    dispatch(apiGetOpeningBalance(token, (res: OpeningBalanceItem[]) => {
      setOtherDebtsDetails(res)
    }));
    dispatch(apiGetAccountingTypes(token, "all"));
    dispatch(apiProductsList({ token }));
    dispatch(apiGetWarehouses(token));
    dispatch(apiGetAccountingTypes(token, undefined, (res: any) => {
      setDebtor(res.childs)
    }, "debtor"));
    dispatch(apiFinancialsList("bank", token));
    dispatch(apiFinancialsList("fund", token));
    dispatch(apiFinancialsList("cashier", token));
    dispatch(apiPersonsList(token));
  }, [token]);



  function getSum(items: OpeningBalanceItem[], key?: string): number {
    if (!items) return 0;
    return items
      .map((x) => {
        let amount = x.price;
        if (key && (x as any)[key]) {
          amount = (x as any)[key];
        }
        return amount || 0;
      })
      .reduce((x, i) => x + i, 0);
  }

  function handleChange(item: OpeningBalanceItem, options?: any, ex?: boolean) {
    let op = Array.isArray(openingBalance) ? [...openingBalance] : [];
    let ind = options && options.row && options.row.ind;
    const index = op.findIndex((x) => x.ind === ind);
    const sameItems = op.filter(({ type, id, ind }) => {
      return type === item.type && !!id && id === item.id && ind !== item.ind;
    });
    const exist = ex !== undefined ? ex : sameItems.length > 0;
    const isValid = index >= 0 && !!item.id;
    // const isValid = index >= 0 && !exist && !!item.id;
    if (isValid) op[index] = item;
    dispatch(setOpeningBalanceData(op));
    setCount((count) => count + 1);
  }

  function handleDelete(row: any) {
    let ind = row && row.ind;
    let op = [...openingBalance];
    op = op.filter((x) => x.ind !== ind);
    dispatch(setOpeningBalanceData(op));
    setCount((count) => count + 1);
  }

  function handleAddRow(type: OpeningBalanceItem["type"]) {
    let op = Array.isArray(openingBalance) ? [...openingBalance] : [];
    const ind = shortid.generate();
    dispatch(setOpeningBalanceData([...op, { type, ind }]));
    setCount((count) => count + 1);
  }

  function withoutAddRow(type: OpeningBalanceItem["type"]) {
    const notAddable: OpeningBalanceItem["type"][] = ["capital", "LegalReserve", "accumulatedProfitOrLoss"];
    if (notAddable.includes(type)) return true;
    return false;
  }

  function withoutMenu(type: OpeningBalanceItem["type"]) {
    const notAddable: OpeningBalanceItem["type"][] = ["capital"];
    if (notAddable.includes(type)) return true;
    return false;
  }

  function handleSubmit() {
    dispatch(
      apiSetOpeningBalance({
        openingBalance: { data: normalizeDataToApi(openingBalance), id: openingBalanceId, date },
        token,
      })
    );
  }

  function normalizeData({ data, key, type, keys }: CreateSelectColProps) {
    if (!data || !Array.isArray(data)) return;
    const newData = data.filter(x => openingBalance.findIndex(r => r.id === x.id && r.type === type) === -1)
    return newData.map((item: any) => {
      let res = {};
      const labelKey = keys && (keys as any)[key];
      for (const key in openingBalanceItemInit) {
        const preferredKey = keys && (keys as any)[key];
        (res as any)[key] = item[preferredKey || key] || (openingBalanceItemInit as any)[key];
      }
      const ind = shortid.generate();
      return {
        item: { ...res, type, ind },
        label: item[labelKey || key] + (item.accountingCode ? " - " + item.accountingCode : ""),
        onChange: handleChange,
      };
    });
  }

  function normalizeSelectOptions(data: any) {
    if (!data || !Array.isArray(data)) return;
    return data.map((item: any) => ({
      ...item,
      item: item,
      label: item.label,
      onChange: (item: any, { row, colKey }: { row: OpeningBalanceItem; colKey: string }) => {
        let res = { ...row };
        (res as any)[colKey] = item.id;
        handleChange(res, { row });
      },
    }));
  }

  function normalizeDataToApi(data: OpeningBalanceItem[]) {
    if (!accountingTypes.all) return [];
    const res = data
      .filter((x) => {
        let accountTypeId = null;
        if (x.accountTypeId) accountTypeId = x.accountTypeId;
        else if (x.account) accountTypeId = x.account.id;
        else if (x.type) accountTypeId = getTypeId(x.type);
        const exceptions = ![49].includes(accountTypeId);
        return x.id && (x.price || x.debtor || x.creditor) && exceptions;
      })
      .map((item) => {
        let res: { [key: string]: string | number | boolean } = {
          isCreditor: item.creditor ? true : false,
        };
        // AccountTypeId
        if (item.accountTypeId) res.accountTypeId = item.accountTypeId;
        else if (item.account) res.accountTypeId = item.account?.id;
        else if (item.type) res.accountTypeId = getTypeId(item.type);

        // DetailId
        if (item.detail) res.detailId = item.detail.id;
        else if (item.detailId) res.detailId = item.detailId;

        // Amount
        if (item.price) res.amount = item.price;
        else if (item.creditor) res.amount = item.creditor;
        else if (item.debtor) res.amount = item.debtor;

        // ChequeDate
        if (item.delegationDate) res.chequeDate = item.delegationDate;

        // PersonId
        if (item.person) res.personId = item.person.id;
        else if (item.personId) res.personId = item.personId;

        if (item.warehouseId) res.warehouseId = item.warehouseId;
        if (item.count) res.quantity = item.count;
        if (item.bank && typeof item.bank === "object") res.chequeIssuingBank = item.bank?.name;
        else if (item.bank && typeof item.bank === "string") res.chequeIssuingBank = item.bank;
        if (item.branch) res.chequeBranch = item.branch;
        if (item.number) res.chequeNumber = +item.number;
        if (item.payTo) res.payTo = item.payTo;
        if (item.chequeId) res.chequeId = item.chequeId

        return res;
      });
    return res;
  }

  const financeTable = (collection: Collection, type: OpeningBalanceItem["type"]): BlockItem["table"] => ({
    headers: [
      { label: "عنوان", hasSort: false },
      { label: "مبلغ", hasSort: false, style: { minWidth: "150px", width: "150px" } },
    ],
    cols: [
      {
        Comp: Select,
        key: "title",
        data: {
          options: normalizeData({
            data: collection,
            key: "title",
            type,
            keys: { price: "balance", title: "name", detailId: "id" },
          }),
        },
      },
      { Comp: Price, key: "price", options: { editable: true } },
    ],
    emptyRow: { ...openingBalanceItemInit, type },
  });

  const getData = (
    type: OpeningBalanceItem["type"],
    options?: { noAutoFill?: boolean; fillCount?: number; id?: number; accountTypeId?: number }
  ) => {
    if (!type || !openingBalance || !Array.isArray(openingBalance)) return [];
    let data = openingBalance.filter((x) => x.type === type);
    //console.log(openingBalance, 'type is ', type)
    if (data.length === 0 && !options?.noAutoFill) {
      data = [];
      const count = options?.fillCount || 5;
      for (let index = 0; index < count; index++) {
        const ind = shortid.generate();
        let res: OpeningBalanceItem = { ...openingBalanceItemInit, type, ind };
        if (options?.id) res.id = options.id;
        if (options?.accountTypeId) res.accountTypeId = options.accountTypeId;
        data.push(res);
      }
      dispatch(setOpeningBalanceData([...openingBalance, ...data]));
    }
    return data;
  };
  function filterOtherAssets(data: any) {
    if (!data) return;
    let childs = data.childs;
    let res = { ...data };
    if (childs && childs.length > 0) {
      res.childs = childs.flatMap((child: any) => {
        if (Object.values(typeIds).includes(child.id)) return [];
        return filterOtherAssets(child);
      });
    }
    return res;
  }
  // const getDebtorData = (data: any) => {
  //   const isArr = Array.isArray(data)
  //   const newRow = []
  //   if (data && isArr) {
  //     for (const row of data) {
  //       if (otherDebtsTypeIds.includes(row.id))
  //         newRow.push(row)
  //       if (row.childs && row.childs.length) {
  //         row.childs = getDebtorData(row.childs)
  //       }

  //     }

  //     return newRow
  //   } else if (data) {
  //     const newData = { ...data }
  //     newData.childs = getDebtorData(newData.childs)
  //     return newData
  //   }
  // }
  const data: { assets: BlockItem[]; debts: BlockItem[]; equity: BlockItem[] } = {
    assets: [
      {
        title: "bank",
        label: "بانک",
        data: getData("bank"),
        amount: getSum(getData("bank")),
        table: financeTable(banks, "bank"),
      },
      {
        title: "cashier",
        label: "صندوق",
        data: getData("cashier"),
        amount: getSum(getData("cashier")),
        table: financeTable(cashiers, "cashier"),
      },
      {
        title: "fund",
        label: "تنخواه گردان",
        data: getData("fund"),
        amount: getSum(getData("fund")),
        table: financeTable(funds, "fund"),
      },
      {
        title: "product",
        label: "موجودی کالا",
        data: getData("product"),
        amount: getSum(getData("product"), "totalPrice"),
        validateOnClose: (setModal) => {
          const products = openingBalance.filter((x) => x.type === "product");
          const invalidProducts = products.filter((x) => x.id && !x.warehouseId);
          if (invalidProducts?.length) {
            const action: any = () => {
              const newOP = openingBalance.filter((x) => !invalidProducts.map((x) => x.ind).includes(x.ind));
              dispatch(setOpeningBalanceData(newOP));
              setModal(false);
            };
            dispatch(
              setConfirm("اخطار",action,undefined,"فیلد ضروری (انبار) را برای یک یا چند ردیف وارد نکرده اید! آیا این ردیف ها نادیده گرفته شوند ؟")
            );
            return;
          }
          setModal(false);
        },
        table: {
          headers: [
            { label: "کالا", style: { minWidth: "150px", right: "45px" }, fixRight: true },
            { label: "واحد", style: { minWidth: "50px" } },
            { label: "بارکد", style: { minWidth: "100px" } },
            // { label: "کد کالا", style: { minWidth: "100px" } },
            { label: "انبار", style: { minWidth: "150px" } },
            { label: "تعداد", style: { minWidth: "70px" } },
            { label: "مبلغ واحد", style: { minWidth: "150px" } },
            { label: "مبلغ کل", style: { minWidth: "200px" } },
          ],
          cols: [
            {
              Comp: Select,
              key: "title",
              data: {
                options: products && products.map((x: any) => ({ item: x, label: x.label })),
              },
              options: {
                onChange: (value: any, { row }: any) => {
                  const ind = row.ind || shortid.generate();
                  let item: OpeningBalanceItem = {
                    type: "product",
                    ind,
                    title: value.title,
                    id: value.id + ind,
                    detailId: value.id,
                    price: value.sellPrice,
                    count: 1,
                    unit: value.unit,
                    barcode: value.barcode,
                  };
                  handleChange(item, { row });
                },
                inputProps: {
                  menuStyle: { minWidth: 300 },
                },
              },
              fixRight: true,
              style: { right: "45px", zIndex: 2 },
            },
            { Comp: Text, key: "unit" },
            { Comp: Text, key: "barcode" },
            // { Comp: Text, key: "detailId" },
            {
              Comp: Select,
              key: "warehouse",
              data: {
                options: warehouses.map((w: any) => ({
                  item: w,
                  label: w.label,
                  onChange: (item: any, { row }: { row: OpeningBalanceItem }) => {
                    const same = openingBalance
                      .filter((x) => x.type === "product")
                      .find((x) => x.detailId === row.detailId && x.warehouseId === item.id);
                    if (same) {
                      dispatch(appSetAlert("موجودی این کالا در انبار انتخاب شده قبلا وارد شده است", "error"));
                      let res = { ...row };
                      handleChange(res, { row });
                      return;
                    }
                    let res = { ...row };
                    res.warehouse = item;
                    res.warehouseId = item.id;
                    handleChange(res, { row });
                  },
                })),
              },
              options: { placeholder: "" },
            },
            {
              Comp: Number,
              key: "count",
              options: {
                editable: true,
                min: 1,
                onChange: (item: any, options: any) => {
                  let newItem = { ...item };
                  newItem.totalPrice = newItem.count * newItem.price;
                  handleChange(newItem, options);
                },
              },
            },
            {
              Comp: Price,
              key: "price",
              options: {
                editable: true,
                currency: "",
                onChange: (item: any, options: any) => {
                  let newItem = { ...item };
                  newItem.totalPrice = newItem.count * newItem.price;
                  handleChange(newItem, options);
                },
              },
            },
            {
              Comp: Price,
              key: "totalPrice",
              options: { conditionalVal: true, operator: "*", keys: ["count", "price"] },
            },
          ],
          emptyRow: { ...openingBalanceItemInit, type: "product" },
        },
      },
      {
        title: "debtor",
        label: "بدهکاران",
        data: getData("debtor"),
        amount: getSum(getData("debtor"), "debtor"),
        table: {
          headers: [{ label: "شخص" }, { label: "مبلغ", style: { width: "150px" } }],
          cols: [
            {
              Comp: Select,
              key: "title",
              data: {
                options: normalizeData({
                  data: allPerson,
                  key: "title",
                  type: "debtor",
                  keys: { debtor: "balance", title: "nickName", detailId: "id" },
                })?.filter(x => openingBalance.findIndex(r => r.type === "debtor" && r.id === x.item.ind) === -1),
              },
            },
            { Comp: Price, key: "debtor", options: { editable: true } },
          ],
          emptyRow: { ...openingBalanceItemInit, type: "debtor" },
        },
      },
      {
        title: "receivableDoc",
        label: "اسناد دریافتنی",
        data: getData("receivableDoc"),
        amount: getSum(getData("receivableDoc"), "debtor"),
        table: {
          headers: [
            { label: "پرداخت کننده", style: { minWidth: "150px" } },
            { label: "شماره", style: { minWidth: "100px" } },
            { label: "مبلغ", style: { minWidth: "150px" } },
            { label: "بانک", style: { minWidth: "150px" } },
            { label: "شعبه", style: { minWidth: "100px" } },
            { label: "تاریخ", style: { minWidth: "150px" } },
          ],
          cols: [
            {
              Comp: Select,
              key: "title",
              data: {
                options:
                allPerson &&
                allPerson.map((x: any) => ({
                  item: x,
                  label: x.nickName + " - " + x.id,
                })).filter((x: any) => openingBalance.findIndex(r => (r.type === "receivableDoc" && (r?.detailId === x.item.id || r?.person?.id === x.item.id))) === -1),
              },
              options: {
                onChange: (value: any, { row }: any) => {
                  const ind = row.ind || shortid.generate();
                  let item: OpeningBalanceItem = {
                    title: value.nickName + " - " + value.id,
                    type: "receivableDoc",
                    ind,
                    id: value.id + ind,
                    person: value,
                    detailId: value.id,
                    date: openingBalanceItemInit.date,
                  };
                  handleChange(item, { row });
                },
              },
            },
            { Comp: Number, key: "number", options: { editable: true } },
            { Comp: Price, key: "debtor", options: { editable: true, currencyKey: "currency" } },
            { Comp: Text, key: "bank", options: { editable: true } },
            { Comp: Text, key: "branch", options: { editable: true } },
            { Comp: DateComp, key: "delegationDate", options: { editable: true } },
          ],
          emptyRow: { ...openingBalanceItemInit, type: "receivableDoc" },
        },
      },
      {
        title: "onGoingDoc",
        label: "اسناد در حال وصول",
        data: getData("onGoingDoc"),
        amount: getSum(getData("onGoingDoc"), "debtor"),
        table: {
          headers: [
            { label: "پرداخت کننده", style: { minWidth: "150px" } },
            { label: "شماره", style: { minWidth: "120px" } },
            { label: "مبلغ", style: { minWidth: "150px" } },
            { label: "بانک", style: { minWidth: "150px" } },
            { label: "شعبه", style: { minWidth: "120px" } },
            { label: "تاریخ", style: { minWidth: "150px" } },
            { label: "بانک در جریان وصول", style: { minWidth: "150px" } },
            { label: "تاریخ واگذاری", style: { minWidth: "150px" } },
          ],
          cols: [
            {
              Comp: Select,
              key: "title",
              data: {
                options:
                  allPerson &&
                  allPerson.map((x: any) => ({
                    item: x,
                    label: x.nickName + " - " + x.id,
                  })).filter((x: any) => openingBalance.findIndex(r => r.type === "onGoingDoc" && r.id === x.item.ind) === -1),
              },
              options: {
                onChange: (value: any, { row }: any) => {
                  const ind = row.ind || shortid.generate();
                  let item: OpeningBalanceItem = {
                    title: value.nickName,
                    type: "onGoingDoc",
                    ind,
                    id: value.id + ind,
                    date: openingBalanceItemInit.date,
                    delegationDate: openingBalanceItemInit.date,
                    person: value,
                    personId: value.id,
                  };
                  handleChange(item, { row });
                },
              },
            },
            { Comp: Number, key: "number", options: { editable: true } },
            { Comp: Price, key: "debtor", options: { editable: true, currencyKey: "currency" } },
            { Comp: Text, key: "bank", options: { editable: true } },
            { Comp: Text, key: "branch", options: { editable: true } },
            { Comp: Text, key: "date", options: { editable: false } },
            {
              Comp: Select,
              key: "onGoingDocBank",
              data: { options: banks && banks.map((x: any) => ({ item: x, label: x.label + " - " + x.id })) },
              options: {
                onChange: (value: any, { row }: any) => {
                  let newRow: OpeningBalanceItem = {
                    ...row,
                    onGoingDocBank: value,
                    detailId: value.id,
                  };
                  handleChange(newRow, { row });
                },
                placeholder: "",
              },
            },
            { Comp: DateComp, key: "delegationDate", options: { editable: true } },
          ],
          emptyRow: { ...openingBalanceItemInit, type: "onGoingDoc" },
        },
      },
      {
        title: "otherAsset",
        label: "سایر دارایی ها",
        data: getData("otherAsset"),
        amount: getData("otherAsset")
          .map(({ debtor, creditor }) => (debtor || 0) - (creditor || 0))
          .reduce((x, i) => x + i, 0),
        table: {
          headers: [
            { label: "حساب", style: { width: "200px" } },
            { label: "تفصیل", style: { width: "200px" } },
            { label: "شرح", style: { width: "100px" } },
            { label: "بدهکار", style: { width: "150px" } },
            { label: "بستانکار", style: { width: "150px" } },
          ],
          cols: [
            {
              Comp: Select,
              key: "account",
              data: { options: filterOtherAssets(accountingTypes?.all?.childs[0]) },
              options: {
                nested: true,
                labelKey: "title",
                onChange: (value: any, { row, colKey }: any) => {
                  const ind = row.ind || shortid.generate();
                  let item: OpeningBalanceItem = {
                    ...openingBalanceItemInit,
                    title: value.title,
                    type: "otherAsset",
                    ind,
                    id: value.id,
                    account: value,
                    debtor: 0,
                    creditor: 0,
                  };
                  handleChange(item, { row });
                  dispatch(
                    apiGetAccountingTypeDetails(value.id, token, (details: any) => {
                      handleChange({ ...item, details }, { row });
                    })
                  );
                },
              },
            },
            {
              Comp: Select,
              key: "detail",
              data: { options: [] },
              options: {
                placeholder: "",
                dependentData: true,
                depKey: "details",
                normalizeFunction: normalizeSelectOptions,
              },
            },
            { Comp: Text, key: "description", options: { editable: true } },
            { Comp: Price, key: "debtor", options: { editable: true } },
            { Comp: Price, key: "creditor", options: { editable: true } },
          ],
          emptyRow: { ...openingBalanceItemInit, type: "otherAsset" },
        },
      },
    ],
    debts: [
      {
        title: "creditor",
        label: "بستانکاران",
        data: getData("creditor"),
        amount: getSum(getData("creditor"), "creditor"),
        table: {
          headers: [
            { label: "شخص", style: { minWidth: "150px" } },
            { label: "مبلغ", style: { width: 200 } },
          ],
          cols: [
            {
              Comp: Select,
              key: "title",
              data: {
                options: normalizeData({
                  data: allPerson,
                  key: "title",
                  type: "creditor",
                  keys: { creditor: "balance", title: "nickName", detailId: "id" },
                }),
              },
            },
            { Comp: Price, key: "creditor", options: { editable: true } },
          ],
          emptyRow: { ...openingBalanceItemInit, type: "creditor" },
        },
      },
      {
        title: "payableDoc",
        label: "اسناد پرداختنی",
        data: getData("payableDoc"),
        amount: getSum(getData("payableDoc"), "creditor"),
        table: {
          headers: [
            { label: "بانک", style: { minWidth: "150px" } },
            { label: "در وجه", style: { minWidth: "150px" } },
            { label: "شماره", style: { minWidth: "100px" } },
            { label: "مبلغ", style: { minWidth: "150px" } },
            { label: "تاریخ", style: { minWidth: "150px" } },
          ],
          cols: [
            {
              Comp: Select,
              key: "title",
              data: { options: banks && banks.map((x: any) => ({ item: x, label: x.label })) },
              options: {
                onChange: (value: any, { row }: any) => {
                  const ind = row.ind || shortid.generate();
                  let item: OpeningBalanceItem = {
                    title: value.label,
                    type: "payableDoc",
                    ind,
                    id: value.id + ind,
                    bank: value,
                    detailId: value.id,
                    date: openingBalanceItemInit.date,
                  };
                  handleChange(item, { row });
                },
              },
            },
            { Comp: Text, key: "payTo", options: { editable: true } },
            { Comp: Number, key: "number", options: { editable: true } },
            { Comp: Price, key: "creditor", options: { editable: true } },
            { Comp: DateComp, key: "delegationDate", options: { editable: true } },
          ],
          emptyRow: { ...openingBalanceItemInit, type: "payableDoc" },
        },
      },
      {
        title: "otherDebt",
        label: "سایر بدهی ها",
        data: getData("otherDebt"),
        amount: getData("otherDebt")
          .map(({ debtor, creditor }) => (creditor || 0) - (debtor || 0))
          .reduce((x, i) => x + i, 0),
        table: {
          headers: [
            { label: "حساب", style: { minWidth: "150px" } },
            { label: "تفصیل", style: { minWidth: "100px" } },
            { label: "شرح", style: { width: "100px" } },
            { label: "بدهکار", style: { width: "150px" } },
            { label: "بستانکار", style: { width: "150px" } },
          ],
          cols: [
            {
              Comp: Select,
              key: "account",
              data: { options: debtor },
              options: {
                nested: true,
                labelKey: "title",
                onChange: (value: any, { row, colKey }: any) => {
                  const ind = row.ind || shortid.generate();
                  let item: OpeningBalanceItem = {
                    ...openingBalanceItemInit,
                    title: value.title,
                    type: "otherDebt",
                    ind,
                    id: value.id,
                    account: value,
                    debtor: 0,
                    creditor: 0,
                  };
                  handleChange(item, { row });
                  dispatch(
                    apiGetAccountingTypeDetails(value.id, token, (details: any) => {
                      handleChange({ ...item, details }, { row });
                    })
                  );
                },
              },
            },
            {
              Comp: Select,
              key: "detailId",
              data: { options: [] },
              options: {
                placeholder: "",
                dependentData: true,
                depKey: "details",
                normalizeFunction: normalizeSelectOptions,
              },
            },
            { Comp: Text, key: "description", options: { editable: true } },
            { Comp: Price, key: "debtor", options: { editable: true } },
            { Comp: Price, key: "creditor", options: { editable: true } },
          ],
          emptyRow: { ...openingBalanceItemInit, type: "otherDebt" },
        },
      },
    ],
    equity: [
      {
        title: "capital",
        label: "سرمایه",
        data: getData("capital", { fillCount: 1 }),
        amount: getData("capital", { fillCount: 1 })
          .map(({ debtor, creditor }) => (creditor || 0) - (debtor || 0))
          .reduce((x, i) => x + i, 0),
        table: {
          headers: [
            { label: "سهامدار", style: { minWidth: "150px" } },
            { label: "بدهکار", style: { minWidth: "150px" } },
            { label: "بستانکار", style: { minWidth: "150px" } },
          ],
          cols: [
            {
              Comp: Text,
              key: "title",
              options: { defaultValue: "سرمایه" },
            },
            { Comp: Price, key: "debtor" },
            { Comp: Price, key: "creditor" },
          ],
          emptyRow: { ...openingBalanceItemInit, type: "capital" },
        },
      },
      {
        title: "LegalReserve",
        label: "اندوخته قانونی",
        data: getData("LegalReserve", { fillCount: 1, id: 1, accountTypeId: 51 }),
        amount: getData("LegalReserve", { fillCount: 1, id: 1, accountTypeId: 51 })
          .map(({ debtor, creditor }) => (creditor || 0) - (debtor || 0))
          .reduce((x, i) => x + i, 0),
        table: {
          headers: [
            { label: "حساب", style: { minWidth: "150px" } },
            { label: "بدهکار", style: { minWidth: "150px" } },
            { label: "بستانکار", style: { minWidth: "150px" } },
          ],
          cols: [
            {
              Comp: Text,
              key: "title",
              options: { defaultValue: "اندوخته قانونی" },
            },
            { Comp: Price, key: "debtor", options: { editable: true } },
            { Comp: Price, key: "creditor", options: { editable: true } },
          ],
          emptyRow: { ...openingBalanceItemInit, type: "LegalReserve" },
        },
      },
      {
        title: "accumulatedProfitOrLoss",
        label: "سود یا زیان انباشته",
        data: getData("accumulatedProfitOrLoss", { fillCount: 1, id: 1, accountTypeId: 54 }),
        amount: getData("accumulatedProfitOrLoss", { fillCount: 1, id: 1, accountTypeId: 54 })
          .map(({ debtor, creditor }) => (creditor || 0) - (debtor || 0))
          .reduce((x, i) => x + i, 0),
        table: {
          headers: [
            { label: "حساب", style: { minWidth: "150px" } },
            { label: "بدهکار", style: { minWidth: "150px" } },
            { label: "بستانکار", style: { minWidth: "150px" } },
          ],
          cols: [
            {
              Comp: Text,
              key: "title",
              options: { defaultValue: "سود یا زیان انباشته" },
            },
            { Comp: Price, key: "debtor", options: { editable: true } },
            { Comp: Price, key: "creditor", options: { editable: true } },
          ],
          emptyRow: { ...openingBalanceItemInit, type: "accumulatedProfitOrLoss" },
        },
      },
    ],
  };
  return {
    date,
    setDate,
    loading,
    data,
    handleDelete,
    handleChange,
    handleSubmit,
    handleAddRow,
    withoutAddRow,
    withoutMenu,
    openingBalance,
    openingBalanceItemInit,
    count,
    deleteOpenningBalanceApi
  };
}
